import React from "react";
import { ButtonToolbar, Well } from "@sketchpixy/rubix";
import styles from "./styles";

const Toolbar = ({ serviceTitle }) => (
  <Well>
    <ButtonToolbar>
      {serviceTitle && (
        <span>
          <span>{serviceTitle}</span>
        </span>
      )}
    </ButtonToolbar>

    {serviceTitle && <hr />}

    <ButtonToolbar>
      <span style={styles.toolbarTitle}>
        لطفا دانش آموزان دریافت کننده را انتخاب کنید
      </span>

      {/* <span style={styles.toolbarWarning}>
        امکان ثبت‌نام دانش‌آموزانی که جنسیت آن‌‌ها مشخص نیست، وجود ندارد. برای وارد کردن
        جنسیت باید از طریق فایل اکسل در بخش افزودن دانش‌آموز جدید، اطلاعات آن‌ها را به روز
        کنید.
      </span> */}
    </ButtonToolbar>
  </Well>
);

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/common/Services/ServiceStudentsSelector/Toolbar.js